import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
import { Section, Eyebrow, SectionTitle } from './ui.jsx';
import { displayFont, monoFont, tokens } from '../theme.js';

export default function Products() {
  const { t } = useTranslation();
  const items = t('products.items', { returnObjects: true });

  return (
    <Section id="solutions" sx={{ bgcolor: tokens.cream }}>
      <Eyebrow>{t('products.eyebrow')}</Eyebrow>
      <SectionTitle>{t('products.title')}</SectionTitle>
      <Typography sx={{ color: 'text.secondary', maxWidth: '68ch', mt: -3, mb: 5 }}>{t('products.intro')}</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}>
        {items.map((item) => (
          <Paper
            key={item.name}
            variant="outlined"
            component="article"
            sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1.25, borderTop: `3px solid ${tokens.teal}` }}
          >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5, width: '100%', mb: 0.5 }}>
              <Typography sx={{ fontFamily: displayFont, fontWeight: 700, fontSize: '1.35rem', color: 'primary.dark' }}>
                {item.name}
              </Typography>
              <Chip label={item.status} size="small" variant="outlined" sx={{ borderRadius: '2px', fontSize: '0.72rem' }} />
            </Box>
            <Typography variant="h4" sx={{ fontSize: '1.05rem' }}>{item.tagline}</Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.95rem' }}>{item.body}</Typography>
            <Typography sx={{ fontFamily: monoFont, color: 'primary.dark', fontSize: '0.7rem', letterSpacing: '0.06em', mt: 'auto', pt: 2 }}>
              {item.audience}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Section>
  );
}
